const fs = require('fs');
const path = require('path');
const glob = require('glob');
const findNodeModules = require("../helpers/findNodeModules");

const nodeModulesDir = findNodeModules(__dirname);

const sldsModule = "@salesforce-ux/design-system";

const globPattern =
  `${nodeModulesDir}/${sldsModule}/metadata/components/*/styling-hooks.json`;

function collectComponentHooks(globPattern) {
  const componentHooks = [];

  glob.sync(globPattern).forEach((file) => {
    const content = JSON.parse(fs.readFileSync(file, "utf-8"));

    // Extract the component name from the file path using the wildcard part
    const componentFolderMatch = file.match(
      /components\/(.+?)\/styling-hooks\.json/
    );
    const componentName = componentFolderMatch ? componentFolderMatch[1] : null;

    // Iterate over each key-value pair in the content and form the new object
    for (const [key, value] of Object.entries(content)) {
      const { valueType, category, ...propValues } = value;
      // Rename the key 'fallbackValue' to 'value'
      if (propValues.hasOwnProperty("fallbackValue")) {
        propValues.value = propValues.fallbackValue;
        delete propValues.fallbackValue;
      }
      componentHooks.push({
        component: componentName,
        name: key,
        scope: "component",
        valueType: valueType && valueType.toLowerCase() || "",
        category: category && category.toLowerCase() || "",
        ...propValues,
      });
    }
  });

  return componentHooks;
}

const result = collectComponentHooks(globPattern);

module.exports = result;

// Optional: write the result to a file
// const outputPath = path.join(__dirname, 'combined-styling-hooks.json');
// fs.writeFileSync(outputPath, JSON.stringify(result, null, 2), 'utf-8');